import React from "react";
import { PageHero, CTABlock, SectionLabel } from "@/components/Sections";
import { ASSETS } from "@/lib/data";
import { Leaf, Award, Recycle, Sprout } from "lucide-react";

const blocks = [
  { icon: Leaf, title: "Mer hållbara produktval", text: "Vi väljer produkter som gör mindre påverkan på miljön i varje uppdrag." },
  { icon: Award, title: "Miljömärkta produkter", text: "Miljömärkta alternativ används när det är möjligt." },
  { icon: Recycle, title: "Ansvarsfull städning", text: "Vi arbetar med medvetenhet om hur våra metoder påverkar miljön." },
  { icon: Sprout, title: "Hållbar utveckling", text: "Små val varje dag som ger stor skillnad över tid." },
];

export default function MiljoHallbarhet() {
  return (
    <>
      <PageHero
        eyebrow="Miljö & hållbarhet"
        title="Bästa resultat – med minsta möjliga påverkan"
        intro="I alla våra tjänster strävar vi efter bästa möjliga resultat med minsta möjliga påverkan på miljön. Rena Tjänster använder produkter som utgör ett mer hållbart val."
        image={ASSETS.ecoFriendly}
        imageAlt="Hållbar städning av Rena Tjänster"
      />

      <section className="py-20 lg:py-28" data-testid="miljo-blocks">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionLabel className="mb-4">Det här betyder det i praktiken</SectionLabel>
          <h2 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900 mb-4 max-w-2xl">
            Hållbarhet i varje uppdrag
          </h2>
          <p className="text-slate-600 leading-relaxed mb-12 max-w-3xl">
            Det betyder att produkterna antingen har miljömärkning eller uppfyller fastställda miljökrav
            från kontrollorganisationer.
          </p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {blocks.map((b, i) => (
              <div key={i} className="bg-white rounded-2xl p-7 border border-slate-100 hover:border-[#F59E0B]/40 transition-all" data-testid={`miljo-block-${i}`}>
                <div className="w-12 h-12 rounded-xl bg-emerald-50 text-emerald-700 inline-flex items-center justify-center mb-4">
                  <b.icon className="h-5 w-5" strokeWidth={1.6} />
                </div>
                <h3 className="font-display text-lg font-semibold text-slate-900 mb-1.5">{b.title}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{b.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTABlock
        title="Vill ni veta mer om vårt miljöarbete?"
        description="Vi pratar gärna om produkter, metoder och hur vi tänker kring hållbarhet i vardagen. Hör av er så berättar vi mer."
      />
    </>
  );
}
